import React from 'react';
import Header from './header'
import TechList from './techlist'

const App = () => {
  return <div>
  <Header />
  <TechList />
  </div>
}
export default App;
